// Components==============
import { useTranslate } from 'hooks/useTranslate';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import React, { useContext, useEffect, useState } from 'react';
import { DeleteModalContext } from '../DeleteModal';
// =========================

export const useSelectedUserLogic = () => {
  const {
    setSelectedUsers,
    userSelectedSelf,
    allUsers,
    transferUser,
    themeIsChecked,
    processIsChecked,
  } = useContext(DeleteModalContext);

  const { studentList, selectedStudent } = useContext(ProjectDetailsContext);

  const translate = useTranslate();

  const selectedUser =
    selectedStudent !== translate('project.terms.my-process')
      ? studentList.find((s) => s.name === selectedStudent)
      : undefined;

  useEffect(() => {
    if (selectedUser)
      setSelectedUsers([
        { user: selectedUser.user, memberId: selectedUser.memberId },
      ]);
  }, []);

  useEffect(() => {
    // select all users if my process is selected
    // This also makes sure that other users can't be deselected
    if (userSelectedSelf) {
      return setSelectedUsers(
        allUsers.map((u) => ({ user: u.user, memberId: u.memberId }))
      );
    }

    setSelectedUsers([]);
  }, [userSelectedSelf]);

  useEffect(() => {
    if (transferUser) {
      return setSelectedUsers(
        allUsers.map((u) => ({ user: u.user, memberId: u.memberId }))
      );
    }

    setSelectedUsers([]);
  }, [transferUser]);

  const [counter, setCounter] = useState(0);
  useEffect(() => {
    setCounter((prev) => prev + 1);
    if (counter < 2) return;
    if (themeIsChecked)
      return setSelectedUsers(
        allUsers.map((u) => ({ user: u.user, memberId: u.memberId }))
      );
    if (processIsChecked) return;

    setSelectedUsers([]);
  }, [themeIsChecked]);

  useEffect(() => {
    setCounter((prev) => prev + 1);
    if (counter < 2) return;

    if (themeIsChecked) return;
    if (processIsChecked)
      return setSelectedUsers(
        allUsers.map((u) => ({ user: u.user, memberId: u.memberId }))
      );

    if (themeIsChecked) return;

    setSelectedUsers([]);
  }, [processIsChecked]);
};

// necessary due to context
export const UserLogicMounter = () => {
  useSelectedUserLogic();

  return <></>;
};
